export const PAYMENT_TYPE = {
  WALLET: "wallet",
  ONLINE: "credit",
};

export const WEEK_INDEX = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
